;(function () {
	if (document.querySelector('.navsci')) {
		return
	}

	if (WC?.idMenu === 136) {
		// Prodotti Tipici
		printBannerMalghe(1)
	} else if (WC?.idMenu === 122) {
		// Mangiare in malga
		printBannerMalghe(2)
	} else {
		return
	}

	function printBannerMalghe(type = 1) {
		const imageUrl = `/images/malghe/banner-malghe-${type}.jpg`

		const el = document.createElement('a')
		el.classList.add('banner-malghe')
		el.classList.add('dkreset')
		el.href = mL('malgheUrl', type)
		el.innerHTML = `
			<div class="banner-malghe__photo">
				<picture class="banner-malghe__picture">
					<img src="${imageUrl}" alt="" class="banner-malghe__image">
				</picture>
			</div>
			<div class="banner-malghe__text">
				<p class="banner-malghe__title">${mL('title', type)}</p>
				<div class="banner-malghe__button">
					<div class="banner-malghe__btntext">${mL('btnText', type)}</div>
				</div>
			</div>`

		document.querySelector('.body-page').appendChild(el)
	}

	function mL(string, type = 1) {
		const data = {
			type1: {
				malgheUrl: {
					it: '/it/malghe/',
					en: '/en/alm/',
					de: '/de/alm/',
				},
				title: {
					it:
						'Scopri anche le <em>Malghe</em> che producono e vendono il <em>Formaggio Asiago DOP</em>',
					en:
						'Discover also the <em>Malghe</em> that produce and sell the <em>Asiago DOP cheese</em>',
					de:
						'Entdecken Sie auch die <em>Malghe</em>, die den <em>Asiago DOP-Käse</em> herstellen und verkaufen',
				},
				btnText: {
					it: 'Scopri',
					en: 'Discover',
					de: 'Entdecken',
				},
			},
			type2: {
				malgheUrl: {
					it: '/it/malghe/',
					en: '/en/alm/',
					de: '/de/alm/',
				},
				title: {
					it:
						'Scopri anche le <em>Malghe</em> con servizio di <em>vendita diretta di formaggio</em> ed altri prodotti',
					en:
						'Discover also the <em>huts</em> with <em>direct sales service of cheese</em> and other products',
					de:
						'Entdecken Sie auch die <em>Hütten</em> mit <em>Direktvertrieb von Käse</em> und anderen Produkten',
				},
				btnText: {
					it: 'Scopri',
					en: 'Discover',
					de: 'Entdecken',
				},
			},
		}

		return data[`type${type}`][string][WC.lang.substr(0, 2)]
	}
})()
